export default function CourseTerms() {
    return (
        <>
            <section id="guitar-course-details-section">
                <div className="guitar-course-details-container">
                    <div className="guitar-course-details-content">
                        <div className="course-detail-item">
                            <h3 className="course-detail-title">TRAINING INVOLVES</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>DAWs (Logic Pro X, Ableton, FL Studio).</li>
                                <li>Recording, sound design, and editing.</li>
                                <li>Mixing, mastering, and beat-making.</li>
                                <li>Songwriting and arrangement.</li>
                                <li>Studio and live production workflow.</li>
                            </ul>
                        </div>

                        <div className="course-detail-item">
                            <h3 className="course-detail-title">Who is it For</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Aspiring producers and composers.</li>
                                <li>Singers wanting to self-produce.</li>
                                <li>DJs and electronic music creators.</li>
                                <li>Students entering the professional music industry.</li>
                            </ul>
                        </div>

                        <div className="course-detail-item">
                            <h3 className="course-detail-title">Learning Outcomes</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Produce professional-quality tracks independently.</li>
                                <li>Compose across multiple genres.</li>
                                <li>Recording and mixing industry-standard audio.</li>
                                <li>Confidence in releasing music commercially.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
} 